<template>
    <div class="col-span-1">
        <h4>Categorías</h4>
        <ul class="sm:flex lg:block items-center flex-wrap mt-8">
            <li class="lg:w-full md:w-1/4 sm:w-1/3 first:mt-0 mt-2">
                <a
                    href="#"
                    @click.prevent="select('')"
                    :class="`block rounded-md text-lg text-gray-400 hover:text-gray-600 hover:bg-gray-200 outline-none transition duration-300 ease-in-out xl:px-12 sm:px-6 px-12 py-2 ${
                        category === '' ? 'text-gray-600 bg-gray-200' : ''
                    }`"
                >
                    Todos
                </a>
            </li>
            <li v-for="item in categories" :key="item.id" class="lg:w-full md:w-1/4 sm:w-1/3 first:mt-0 mt-2">
                <a
                    href="#"
                    :id="item.slug"
                    @click.prevent="select(item.slug)"
                    :class="`block rounded-md text-lg text-gray-400 hover:text-gray-600 hover:bg-gray-200 outline-none transition duration-300 ease-in-out xl:px-12 sm:px-6 px-12 py-2 ${
                        item.slug === category ? 'text-gray-600 bg-gray-200' : ''
                    }`"
                >
                    {{ item.name }}
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    model: {
        prop: 'category',
    },

    props: {
        category: {
            type: String,
            default: '',
        },
        categories: {
            type: Array,
            required: true,
        },
    },

    methods: {
        select(slug) {
            this.$emit('input', slug);
        },
    },
};
</script>
